// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"style_NotFound__2Eolo","Text":"style_Text__2zzjb"};